export function homeLocations() {
    $(".gallery-locations").each(function () {
        $(this).slick({
            infinite: true,
            arrows: true,
            fade: true,
            speed: 499,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        adaptiveHeight: true,
                    }
                }
            ]
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/home-locations.js